import { Form } from 'factorial-form'

class WorkInformation extends Form {
  constructor(values: {}) {
    super(values, {
      manager_id: 'string',
      location_id: 'string',
      employee_group_id: 'string',
      timeoff_manager_id: 'string',
      payrollable: 'boolean',
      company_identifier: 'string',
      contract_version_starts_on: 'date',
      show_birthday: 'boolean',
      seniority_calculation_date: 'string',
    })
  }
}

export default WorkInformation
